<div class="ecus-login-bgr image-bgr">
  <div class="uk-container uk-height-1-1">
    <div
      class="uk-flex-middle uk-flex-center uk-grid-collapse uk-width-1-1 uk-height-1-1"
      uk-grid
    >
      <div class="uk-width-2-3@s uk-width-2-5@m uk-text-center">
        <div
          class="uk-form form-signin form-signin-white"
        >
          <h1 class="uk-text-center"><strong>ECOM</strong></h1>
          <p class="uk-text-center">Ecus Customs Order Management</p>

          <h3 class="form-signin-heading"><strong>FEL</strong></h3>

          <div
            class="error-message uk-margin-top uk-text-danger"
            *ngIf="error != null"
          >
            <span>{{ error }}</span>
          </div>
      </div>
    </div>
  </div>
</div>
<welcome-footer></welcome-footer>
